// extracted by mini-css-extract-plugin
export default {"root":"Secondary_root__ReCAv Button_root__dDO5g Button_base__ncFXu"};